/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Quarterlydata_Subtitle2Inputs */

const en_coinvestments_report_quarterlydata_subtitle2 = /** @type {(inputs: Coinvestments_Report_Quarterlydata_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible to invested organisations on save`)
};

/**
* | output |
* | --- |
* | "Visible to invested organisations on save" |
*
* @param {Coinvestments_Report_Quarterlydata_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_quarterlydata_subtitle2 = /** @type {((inputs?: Coinvestments_Report_Quarterlydata_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Quarterlydata_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_quarterlydata_subtitle2(inputs)
});
export { coinvestments_report_quarterlydata_subtitle2 as "coInvestments_report_quarterlyData_subtitle" }